// i18n: Italian is the only language in v1. Add an `en` dictionary with the same keys to enable English.
const it = {
  "nav.scopri": "Scopri",
  "nav.daily": "Daily",
  "nav.pubblica": "Pubblica",
  "nav.attivita": "Attività",
  "nav.messaggi": "Messaggi",
  "nav.profilo": "Profilo",
  "nav.cerca": "Cerca",
  "nav.admin": "Admin",
  "feed.per_te": "Per te",
  "feed.seguiti": "Seguiti",
  "feed.reveal": "Scopri chi c'è dietro",
  "feed.empty": "Ancora niente qui. Sii il primo a farti vedere.",
  "bussa.none": "Bussa",
  "bussa.sent": "Richiesta inviata",
  "bussa.connected": "Connessi",
  "bussa.rejected": "Rifiutata",
  "bussa.received": "Ti ha bussato",
  "follow.on": "Segui già",
  "follow.off": "Segui",
};

export type Lang = "it";
const dicts: Record<Lang, Record<string, string>> = { it };
let lang: Lang = "it";

export const setLang = (l: Lang) => { lang = l; };
export const t = (key: keyof typeof it): string => dicts[lang][key] ?? key;
